import React, { useEffect } from 'react';
import { sendTrackingInfo, ModalCreditsOptions } from '@panel/commons';
import { useTranslation } from 'react-i18next';

function FreemiumFlowOffToOnCreditsYesFreeYes(props) {
  const { onClickAction, onClickSelect, onClickFreemium, plans, defaultPlan, onClickOutside, isInmobiliaria } = props;
  const { t } = useTranslation();

  useEffect(() => {
    const txt = `Republicar Aviso_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}-Intencion`;
    sendTrackingInfo('Mis avisos', txt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAction = e => {
    const txt = `Republicar Aviso Con credito_Usar Creditos_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}`;
    sendTrackingInfo('Mis avisos', txt);
    onClickAction(e);
  };

  const handleFreemium = e => {
    const txt = `Republicar Aviso Con credito_Activar Gratis_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}`;
    sendTrackingInfo('Mis avisos', txt);
    onClickFreemium(e);
  };

  const handleClickOutside = () => {
    const txt = `Republicar Aviso Con credito_Cancelar_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}`;
    sendTrackingInfo('Mis avisos', txt);
    onClickOutside();
  };

  return (
    <ModalCreditsOptions
      onClickAction={e => handleAction(e)}
      onClickSelect={onClickSelect}
      onClickFreemium={e => handleFreemium(e)}
      onClickOutside={handleClickOutside}
      plans={plans}
      defaultPlan={defaultPlan}
      title={t('panel.modal.FreemiumFlowOffToOnCreditsYesFreeYes.title')}
      subTitle={t('panel.modal.FreemiumFlowOffToOnCreditsYesFreeYes.subtitle')}
      ctaFreemium={t('panel.modal.cta.freeActivation')}
      ctaOk={t('panel.modal.cta.useCredits')}
    />
  );
}

export { FreemiumFlowOffToOnCreditsYesFreeYes };
